import {LogementService} from "./logement.service";
import {map} from "rxjs/operators";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  constructor(
    private logementService: LogementService
  ) {
  }
  public showAnnouncements() {
    return this.logementService.logementCourant.pipe(map(logement => {
        if (logement?.societe?.partner?.showAnnouncements === false) {
          return logement?.societe?.partner?.showAnnouncements
        }

        return true
      }
    ))
  }
}
